import React from "react";
import { NavLink } from "react-router-dom";

function Navbar({ menuOpen, setMenuOpen }) {
  const handleLinkClick = () => setMenuOpen(false);

  return (
    <nav className={`navbar ${menuOpen ? "open" : ""}`}>
      <ul className={`nav-list ${menuOpen ? "show" : ""}`}>
        <li>
          <NavLink to="/" end onClick={handleLinkClick}>
            Home
          </NavLink>
        </li>
        <li>
          <NavLink to="/about" onClick={handleLinkClick}>
            About
          </NavLink>
        </li>
        <li>
          <NavLink to="/services" onClick={handleLinkClick}>
            Services
          </NavLink>
        </li>
        <li>
          <NavLink to="/contact" onClick={handleLinkClick}>
            Contact
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
